module.exports = __webpack_public_path__ + "static/img/img_o.f3adbbf4.png";